module.exports = __webpack_public_path__ + "img/danye4.9830ccda.jpg";